var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React from "react";
import Input from "../Input/Input";
/** For use with local date-time inputs */
export function convertToDateTimeLocalString(date, includeTime = true) {
    if (!date)
        return undefined;
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    if (!includeTime)
        return `${year}-${month}-${day}`;
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
/**
 * A component that allows the user to select a date.
 * @deprecated Use Input with type="date" or "datetime-local" instead.
 */
export function Datepicker(_a) {
    var { date, dateFormat, isPickingTime = false, maxDate, minDate, onDateChange, name } = _a, props = __rest(_a, ["date", "dateFormat", "isPickingTime", "maxDate", "minDate", "onDateChange", "name"]);
    const min = convertToDateTimeLocalString(minDate, isPickingTime);
    const max = convertToDateTimeLocalString(maxDate, isPickingTime);
    return (React.createElement(Input, Object.assign({ min, max }, props, { type: isPickingTime ? "datetime-local" : "date", name: name, value: convertToDateTimeLocalString(date, isPickingTime), onChange: (event) => onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(new Date(event.target.value)) })));
}
export default Datepicker;
//# sourceMappingURL=Datepicker.js.map